import Base from './action-base'
import renderFields from './goto-scene.pug'

export default class GotoScene extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-arrow-right"

  @DEFAULTS:
    target: "main"
    sceneId: null
    reuse: false
    transition: null
    transitionDuration: 1.0

  renderFields: renderFields
